import styled from 'styled-components';
import { GREEN_COLOR } from '../constants';

export const SignupContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 3rem;
  align-items: center;
  @media (max-width: 968px) {
    grid-template-columns: 1fr;
  }
`;

export const SignupImage = styled.img`
  width: 100%;
  height: 400px;
  object-fit: cover;
  border-radius: 16px;
  @media (max-width: 968px) {
    height: 300px;
  }
  @media (max-width: 768px) {
    height: 250px;
  }
`;

export const SignupForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  width: 100%;
`;

export const InputWrapper = styled.div`
  position: relative;
`;

export const Input = styled.input`
  padding: 1rem;
  border: 1px solid ${({ error }) => (error ? '#e11d48' : '#d1d5db')};
  border-radius: 8px;
  font-size: 1rem;
  width: 100%;
  background: #f9fafb;
  box-sizing: border-box;
  transition: all 0.2s;

  &:focus {
    outline: none;
    border-color: ${({ error }) => (error ? '#e11d48' : GREEN_COLOR)};
    box-shadow: 0 0 0 3px
      ${({ error }) => (error ? 'rgba(225,29,72,0.1)' : 'rgba(65,96,54,0.1)')};
  }
`;

export const Label = styled.label`
  font-size: 1rem;
  font-weight: 500;
  color: #1f2937;
  margin-bottom: 0.5rem;
  display: block;
  text-align: left;
`;

export const ErrorMessage = styled.p`
  color: #e11d48;
  font-size: 0.875rem;
  margin-top: 0.5rem;
  font-weight: 500;
`;
